// Create a default prop getter
export const defaultPropGetter = () => ({});